// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__ceNjm","spin":"spinner_spin__T-ntE"};